import { useState, useEffect } from "react";

export const Footer = () => {
  const [utc, setUtc] = useState("");
  useEffect(() => {
    const tick = () => setUtc(new Date().toUTCString().slice(17, 25));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer data-testid="footer-section" className="relative pt-20 pb-10 border-t border-white/10 bg-[#020204] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex flex-col sm:flex-row items-start sm:items-end justify-between gap-8">
        <div className="font-mono-z text-xs text-[#8e8ea0] space-y-2 uppercase tracking-[0.2em]">
          <p data-testid="footer-clock">UTC {utc}</p>
          <p>
            Status: <span className="text-[#00f0ff]">Pre-Launch</span>
          </p>
          <p>© {new Date().getFullYear()} Zavico.net — All frequencies reserved.</p>
        </div>
        <p className="font-mono-z text-xs text-[#8e8ea0]/60 uppercase tracking-[0.3em]">Do not adjust your signal.</p>
      </div>
      <div aria-hidden className="select-none pointer-events-none font-display font-extrabold uppercase leading-none text-[22vw] text-center text-white/[0.03] mt-10 -mb-[6vw] tracking-tighter">
        Zavico
      </div>
    </footer>
  );
};

export default Footer;
